import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import descriptionTextBg from '../../../images/Group 1.png';
import './TrustUsDescription.css';

const trustHeadTextBg = {
    backgroundImage: `url(${descriptionTextBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}

const TrustUsDescription = () => {
    return (
        <div id="trustLeftBg">
            <Box id="trustRightBg">
                <Box id="trustDotedBg">
                    <Container>
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography variant="h3" style={trustHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                                we get your concept learned
                            </Typography>
                            <Box sx={{ px: '2%' }}>
                                <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ textAlign: 'left', py: 9 }}>
                            <Typography variant="h3" style={trustHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                                we brainstorm
                            </Typography>
                            <Box sx={{ px: '2%' }}>
                                <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography variant="h3" style={trustHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                                we pitch you our design
                            </Typography>
                            <Box sx={{ px: '2%' }}>
                                <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ textAlign: 'left', py: 9 }}>
                            <Typography variant="h3" style={trustHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                                we togather make it successful
                            </Typography>
                            <Box sx={{ px: '2%' }}>
                                <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </div>
    );
};

export default TrustUsDescription;